/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserPendingGroupEntity } from './userPendingGroupEntity';
import { GeoLocationEntity } from './geoLocationEntity';


export interface GroupProps { 
    _id?: string;
    name: string;
    parentGroupId?: string;
    location?: GeoLocationEntity;
    description: string;
    ownerId: string;
    creatorId?: string;
    sportId: string;
    privacy: GroupProps.PrivacyEnum;
    rightCreateActivity: GroupProps.RightCreateActivityEnum;
    usersJoined: Array<string>;
    invitedIds: Array<string>;
    admins: Array<string>;
    pendingInviteUsers: Array<UserPendingGroupEntity>;
    backgroundUrl?: string;
    websiteUrl?: string;
    canPublish?: boolean;
    deletedAt?: string;
    deletedBy?: string;
    allowActivitySharing?: boolean;
    handiFriendly?: boolean;
}
export namespace GroupProps {
    export type PrivacyEnum = 'public' | 'private' | 'hidden';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        Hidden: 'hidden' as PrivacyEnum
    };
    export type RightCreateActivityEnum = 'allMembers' | 'onlyAdmin';
    export const RightCreateActivityEnum = {
        AllMembers: 'allMembers' as RightCreateActivityEnum,
        OnlyAdmin: 'onlyAdmin' as RightCreateActivityEnum
    };
}


